import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { AmountHelper } from "../../../../helpers/AmountHelper";
import { useTranslation } from "react-i18next";
import { NFLookupIncomeItem } from "../../../Shared/NewForms/NFLookupIncomeItem";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFLookupBaseDocuments } from "../../../Shared/NewForms/NFLookupBaseDocuments";
import { NFLookupPaymentRequests } from "../../../Shared/NewForms/NFLookupPaymentRequests";

export const ProductionAndSalesWithPaymentsDetailPayments = () => {
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"payment"}>
                <NFIntInput title={t("Payment")} fieldName="paymentType" />
                <NFIntInput title={t("Amount")} fieldName="amount" />
                <NFLookupPaymentRequests
                    fieldName="paymentAccountId"
                    title={t("PaymentAccount")}
                />
            </NFormTable>
        </>
    );
};
